import axiosConfig from "./axiosConfig";

// When the signed-in user last looked at Upcoming and Proposals, on any device
// (User.last_seen_*_at on the server). The Upcoming and Proposals hooks poll at
// the same moments, so a read that lands within a second of another shares its
// request instead of repeating it.
let inflight = null;

export const fetchSeen = () => {
  if (!inflight) {
    inflight = axiosConfig.get("/api/users/seen/").then((res) => res.data);
    const release = () => setTimeout(() => (inflight = null), 1000);
    inflight.then(release, release);
  }
  return inflight;
};

// what: "upcoming" | "proposals". Resolves with both times, now updated.
export const markSeenOnServer = (what) => {
  inflight = null;
  return axiosConfig.post("/api/users/seen/", { what }).then((res) => res.data);
};
